<template>
    <div>
        <h2>Partner Schools Near You</h2>
        <ul class="school__results">
            <li class="school" v-for="school, idx in schoolsByLocation()" :key="idx">
                <div class="school__status"><strong>{{school.Status}} School</strong></div>
                <details>
                    <summary class="school__name">{{school.Name}}</summary>
                    
                    <a  :href="school.Website" 
                        v-if="school.Website && school.Website.includes('https')"
                        target="_blank"
                        rel="nofollow">{{school.Website}}<br /></a>
                    {{school.Address}}<br />
                    {{school.City}}, {{school.State}} {{school.ZIP}}<br />
                </details>
            </li>
        </ul>
    </div>
</template>

<script>
import {store} from '@/store';
import schoolData from "@/api/schools.json";
export default {
    name : 'SchoolList',
    data: () => ({
        sharedStore: store.state,
        locations : {
            list : schoolData
        }
    }),
    methods : {
        schoolsByLocation() {
            return this.locations.list.filter( school => {
                return school.State == this.sharedStore.location.state
            } )
        }
    }
}
</script>

<style lang="scss">
    .school {
        &__results {
            list-style: none;
            padding-left: 0;

            display: grid;
            grid-gap: 2rem;
            grid-template-columns: repeat(2, 1fr);
        }
    }
</style>